import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { IFormInformation, ILabomatesResponse } from '../lab-pass-types';
import { catchError, filter, switchMap, takeUntil } from 'rxjs/operators';
import { CityId } from '@shared/types/storage';
import { WebApiB2B, WebApiLabomat } from '@shared/enums/routes';
import { StorageService } from '@shared/core/services/storage.service';
import { ErrorService } from '@shared/core/services/error.service';
import { DatasourceService } from '@shared/core/services/datasource.service';
import { HttpResponseStatuses } from '@shared/enums/http-statuses';
import { ErrorMessages } from '@shared/types/error-messages.enum';
import { ModalService } from '@shared/services/modal/modal.service';

@Injectable()
export class LabPassDataSourceService implements OnDestroy {
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private errorService: ErrorService,
    private dataSource: DatasourceService,
    private modal: ModalService
  ) {
    this.errorHandler();
  }

  private ngUnsubscribe$ = new Subject<void>();

  getLabomates(): Observable<ILabomatesResponse[]> {
    return this.storageService.cityId$.pipe(
      filter((cityId: CityId) => !!cityId),
      switchMap((cityId: CityId) => {
        return this.http.get<ILabomatesResponse[]>(
          `${WebApiLabomat.Labomats}/${cityId}/locations`
        );
      }),
      catchError((error) => {
        if (error.status === HttpResponseStatuses.BadRequest)
          this.errorService.error$.next(ErrorMessages.Common);

        return this.dataSource.errorHandler(error);
      })
    );
  }

  sendFeedbackPass(info: IFormInformation): Observable<any> {
    return this.http.post(WebApiB2B.LabPass, info);
  }

  private errorHandler(): void {
    this.errorService.error$
      .pipe(
        filter((error): error is string => !!error),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((error) => {
        this.modal.createBusinessLogicError(error);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
